import styled from 'styled-components';

import { borderRadius16 } from 'approot/shared/styles/borders.style';
import { BoxPanel } from 'approot/shared/styles/box-panel.style';
import {
  orange1,
  orange9,
  purple1,
  purple9,
  red1,
  red9,
} from 'approot/shared/styles/colours.style';

export interface BannerStyledProps {
  $size?: 'default' | 'small';
}

function getBannerPadding($size: BannerStyledProps['$size']): number {
  return $size === 'small' ? 12 : 16;
}

/**
 * Danger variant: light red background (red1), red text (red9), uses BoxPanel for layout.
 * Use for warning or destructive messaging.
 */
export const DangerBannerStyled = styled(BoxPanel).attrs<BannerStyledProps>(
  ({ $size }) => ({
    $backgroundColor: red1,
    $borderColor: red1,
    $borderRadius: borderRadius16,
    $padding: getBannerPadding($size),
  })
)`
  color: ${red9};
  position: relative;
`;

/**
 * Warning variant: light orange background (orange1), orange text (orange9), uses BoxPanel for layout.
 * Use for warning messaging.
 */
export const WarningBannerStyled = styled(BoxPanel).attrs<BannerStyledProps>(
  ({ $size }) => ({
    $backgroundColor: orange1,
    $borderColor: orange1,
    $borderRadius: borderRadius16,
    $padding: getBannerPadding($size),
  })
)`
  color: ${orange9};
  position: relative;
`;

/**
 * Info-purple variant: light purple background (purple1), purple text (purple9), uses BoxPanel for layout.
 * Use for informational messaging.
 */
export const InfoPurpleBannerStyled = styled(BoxPanel).attrs<BannerStyledProps>(
  ({ $size }) => ({
    $backgroundColor: purple1,
    $borderColor: purple1,
    $borderRadius: borderRadius16,
    $padding: getBannerPadding($size),
  })
)`
  color: ${purple9};
  position: relative;
`;
